import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a68dc16a875aa001471a16b_1788360652713_7e085d2e/negociofacil/src/app/page.tsx");
